/** 手感时序常量 —— 集中可调 */
export const FEEL = {
  shootCooldownMs: 160,
  bulletSpeed: 520,        // px/s at design radius 360
  hostileSpeed: 380,
  playerAngularSpeed: 4.2, // rad/s max when dragging
  floatScoreMs: 700,
  deathFreezeMs: 220,
  spawnIntervalMs: 1400,
  maxOrbs: 6,
  hitShakeMs: 100,
  hitShakePx: 4,
  scoreBase: 100,
  streakBonus: 25,
  nearCenterR: 28,         // reverse when bullet reaches this radius
  orbRadius: 22,
  playerSize: 16,
  ringThickness: 18,
};
